__turbopack_context__.v({
  "dial": "styles-module-scss-module__92HuNq__dial",
  "dial__outOf": "styles-module-scss-module__92HuNq__dial__outOf",
  "dial__readout": "styles-module-scss-module__92HuNq__dial__readout",
  "dial__score": "styles-module-scss-module__92HuNq__dial__score",
  "dial__segment": "styles-module-scss-module__92HuNq__dial__segment",
  "dial__segment_modLookingGood": "styles-module-scss-module__92HuNq__dial__segment_modLookingGood",
  "dial__segment_modNeedsAttention": "styles-module-scss-module__92HuNq__dial__segment_modNeedsAttention",
  "dial__segment_modUnfilled": "styles-module-scss-module__92HuNq__dial__segment_modUnfilled",
  "dial__segment_modWorthLook": "styles-module-scss-module__92HuNq__dial__segment_modWorthLook",
  "dial__svg": "styles-module-scss-module__92HuNq__dial__svg",
});
